import * as React from "react";
import { useDispatch, useSelector } from "@teamprevent/admin-redux";
import { Button, Modal, Loader } from "semantic-ui-react";

import { goToParent } from "@teamprevent/common/routing";

import { routeIdSelector as customerIdSelector } from "../../crud/customer/selectors";
import { routeIdSelector as employeeRecordIdSelector } from "../../crud/employeeRecord/selectors";
import { EditGPSpecialistInfo, GPSpecialistInfo, isEditModelValid } from "../models";
import { generalPractitionerSpecialistApi } from "../gpSpecialistInfoApi";

import { WritableGPSpecialistInfoForm } from "./WritableGPSpecialistInfoForm";

interface Props {
    gpSpecialistInfo: EditGPSpecialistInfo;
    afterEdit: (updatedModel: GPSpecialistInfo) => void;
}

export const Edit: React.FunctionComponent<Props> = (props: Props) => {
    const dispatch = useDispatch();

    const customerId = useSelector(customerIdSelector);
    const employeeRecordId = useSelector(employeeRecordIdSelector);

    const [model, setModel] = React.useState<EditGPSpecialistInfo>(props.gpSpecialistInfo);
    const [saving, setSaving] = React.useState(false);
    const [submitted, setSubmitted] = React.useState<boolean>(false);

    const onModelChange = React.useCallback(
        (updatedModel: GPSpecialistInfo) => setModel(updatedModel),
        []
    );

    const onSave = async () => {
        setSubmitted(true);
        if (!isEditModelValid(model)) {
            return;
        }
        setSaving(true);

        const updatedModel = await generalPractitionerSpecialistApi.edit(customerId, employeeRecordId, model);

        props.afterEdit(updatedModel);

        setSaving(false);
        onClose();
    };

    const onClose = () => dispatch(goToParent());

    if (!model) {
        return <Loader />;
    }

    return (
        <>
            <Modal open size="small" closeOnDimmerClick={false}>
                <Modal.Header>Edit GP/Specialist Info</Modal.Header>
                <Modal.Content>
                    <WritableGPSpecialistInfoForm model={model} onChange={onModelChange} showErrors={submitted} />
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={onClose}>Cancel</Button>
                    <Button loading={saving} disabled={saving} onClick={onSave} content="Save" />
                </Modal.Actions>
            </Modal>
        </>
    );
};
